export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_NA-fr-FR.5935a6fa.xlsx";